
















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Button, Dialog, Toast, Empty } from "vant";

@Component({
  components: {
    [Button.name]: Button,
    [Empty.name]: Empty
  }
})
export default class TransferIntoInland extends Vue {
  bankInfo: any = {};
  subAccount: any = {};
  requestFail = false;
  IMG_NET_ERR = (this as any).IMG_NET_ERR;

  get copyText() {
    return this.$t("funds.into.others[0]");
  }

  created() {
    this.getBankInfoData();
  }

  get isClickable() {
    return this.subAccount && this.subAccount.payee_sub_account;
  }

  /**
   * 获取银行及账户信息
   */
  getBankInfoData() {
    (this as any).$apis
      .getRechargeSubAccount()
      .then(res => {
        this.requestFail = false;
        [this.bankInfo, this.subAccount] = [res.bank_info, res.sub_account];
      })
      .catch(() => {
        this.requestFail = true;
      });
  }

  /**
   * 复制成功回调
   */
  onCopySuccess() {
    Toast(this.$t("funds.into.others[6]"));
  }

  /**
   * 申请子账户
   * 如果没有子账户，才会展示和渲染
   */
  handleApplySubAccount() {
    const params = {
      remittance_bank_id: this.bankInfo.id
    };
    (this as any).$apis
      .applySubAccount(params)
      .then(() => {
        Dialog.alert({
          title: `${this.$t("funds.into.others[3]")}`,
          confirmButtonText: `${this.$t("funds.into.others[4]")}`,
          message: `${this.$t("funds.into.others[5]")}`
        })
          .then(() => {})
          .catch(() => {});
      })
      .catch(err => {
        
      });
  }

  /**
   * 跳转到上传凭证
   */
  handleButtonClick() {
    this.$router.push({
      name: "credentials-upload",
      query: {
        ...this.$route.query,
        id: this.bankInfo.id
      }
    });
  }
}
